import moduleRegistry from '../module-registry/module-registry';

const config = {
    openCloseDelayMs: 20,
    selectors: {
        share: '.share',
        shareHead: '.share__head',
        shareLinks: '.share__links',
        shareWrapper: '.share__wrapper',
    },
    classNames: {
        shareWrapperActive: 'share__wrapper--active',
        shareHeadActive: 'share__head--active',
        shareLinksActive: 'share__links--active',
    },
};

class Share {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._isVisible = false;
    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListeners();

        this._initShariff();
    }

    async _initShariff() {
        // fetch data
        const finishedSplittedUrl = this._extractIsoAndLanguageFromUrl();
        let data;

        if(window.location.hostname === 'localhost') {
            data = await $.get('/assets/shariff.json');          
        } else {
            try {
                data = await $.get( `/${finishedSplittedUrl.isoCode}/${finishedSplittedUrl.languageSelected}/shariff.json`);
            } catch (error) {
                data = 
                [
                    {
                        "icon": "mail",
                        "country": ""
                    },
                    {
                        "icon": "twitter",
                        "country": ""
                    },
                    {
                        "icon": "facebook",
                        "country": ""
                    },
                    {
                        "icon": "linkedin",
                        "country": ""
                    },
                    {
                        "icon": "whatsapp",
                        "country": ""
                    },
                    {
                        "icon": "xing",
                        "country": ""
                    }
                ];
            }
        }

        const services = [];

        data.forEach(element => {
            if(element.country === '') {
                services.push(element.icon);
                return;
            }

            const isos = element.country.split(';');

            if(isos.includes(finishedSplittedUrl.isoCode.toUpperCase())) {
                services.push(element.icon);
            }
            
        });

        const lang = this._elements.$shareLinks.data('lang');

        // init shariff
        new Shariff(this._elements.$shareLinks, {
            services: services,
            orientation: 'vertical',
            theme: 'white',
            mailUrl: 'mailto:',
            lang: lang,
        });
    }

    /**
     * Returns an object contain the required
     * DOM elements as jQuery objects
     * @returns {object} - An object contain the DOM elements
     */
    _getDomElements() {
        const elements = {
            $shareHeads: this._$rootElement.find(config.selectors.shareHead),
            $shareLinks: this._$rootElement.find(config.selectors.shareLinks),
            $shareWrapper: this._$rootElement.find(config.selectors.shareWrapper),
        };

        return elements;
    }

    _show() {
        this._elements.$shareLinks.addClass(config.classNames.shareLinksActive);
        this._elements.$shareHeads.addClass(config.classNames.shareHeadActive);
        this._elements.$shareWrapper.addClass(config.classNames.shareWrapperActive);
    }

    _hide() {
        this._elements.$shareLinks.removeClass(config.classNames.shareLinksActive);
        this._elements.$shareHeads.removeClass(config.classNames.shareHeadActive);
        this._elements.$shareWrapper.removeClass(config.classNames.shareWrapperActive);
    }

    _extractIsoAndLanguageFromUrl() {
        const currentUrl = window.location.pathname;
        const splittedUrl = currentUrl.split('/')
        const splittedIsoCode = splittedUrl[1]
        const splittedLanguage = splittedUrl[2]
        return {
          isoCode: splittedIsoCode,
          languageSelected: splittedLanguage
        }
    }

    _addEventListeners() {
        this._elements.$shareHeads.click((e) => {
            e.stopPropagation();

            if (!this._isVisible) {
                this._show();
            } else {
                this._hide();
            }

            this._isVisible = !this._isVisible;
        });

        this._elements.$shareHeads.on('keydown', (e) => {
            if (e.keyCode !== 13) return;

            e.stopPropagation();

            if (!this._isVisible) {
                this._show();
            } else {
                this._hide();
            }

            this._isVisible = !this._isVisible;
        });

        this._elements.$shareWrapper.click((e) => {
            e.stopPropagation();
        });

        $(document).click(() => {
            this._hide();
            this._isVisible = false;
        });
    }
}

moduleRegistry.registerModule('Share', Share);
moduleRegistry.autoApplyModule('Share', config.selectors.share);
